import React, { useState } from "react";
import { ocrUpload } from "../../../services/ocrApi";


export default function DocOcrUploader() {
  const [files, setFiles] = useState(null);
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    if (!files?.length) return;
    try {
      setBusy(true);
      const fd = new FormData();
      Array.from(files).forEach((f) => fd.append("files", f));
      const json = await ocrUpload(fd);
      setText(json?.text || "");
    } catch (err) {
      setError("OCR upload failed");
      console.error(err);
    } finally {
      setBusy(false);
    }
  };

  return (
    <form onSubmit={onSubmit} className="space-y-3">
      <input
        type="file"
        multiple
        accept="image/*,.pdf"
        onChange={(e) => setFiles(e.target.files)}
      />
      <button className="px-4 py-2 border rounded" disabled={busy}>
        {busy ? "Prepoznajem..." : "OCR"}
      </button>
      {error && <div className="text-red-600 text-sm">{error}</div>}
      {text && (
        <>
          <h4 className="font-semibold mt-4">Rezultat</h4>
          <pre className="whitespace-pre-wrap p-2 bg-gray-100 rounded">{text}</pre>
        </>
      )}
    </form>
  );
}
